export default __webpack_public_path__ + "static/media/0056.136798c7.png";